import React, { useState } from 'react';

const Chip = ({ onDelete, value }) => {
  const [showDeleteIcon, setShowDeleteIcon] = useState(false);
  return <div onMouseEnter={() => setShowDeleteIcon(true)} onMouseLeave={() => setShowDeleteIcon(false)} className="py-1 px-2 bg-neutral-20 dark:bg-grey-800 flex-row items-center rounded-full inline-block relative ">
    <div className="flex items-center  ">
      <p className="font-Inter text-sm">{value}</p>
      <svg
        viewBox="0 0 21 21"
        fill="currentColor"
        height="24px"
        width="24px"
        className={`cursor-pointer hover:scale-110 transform transition-all duration-300 ease-in-out absolute right-0 bg-neutral-40 dark:bg-grey-800 rounded-full   ${showDeleteIcon ? 'block' : 'hidden'}`}
        onClick={() => onDelete(value)}
      >
        <g
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(2 2)"
        >
          <path d="M5.5 5.5l6 6M11.5 5.5l-6 6" />
        </g>
      </svg>
    </div>

  </div>;
};

export default Chip;
